namespace RioERP.Orders {
    export interface EaseBuzzSettingsRow {
        Id?: number;
        Key?: string;
        Salt?: string;
        WebhookUrl?: string;
        RedirectUrl?: string;
        IsActive?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace EaseBuzzSettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Key';
        export const localTextPrefix = 'Orders.EaseBuzzSettings';
        export const lookupKey = 'Orders.EaseBuzzSettings';

        export function getLookup(): Q.Lookup<EaseBuzzSettingsRow> {
            return Q.getLookup<EaseBuzzSettingsRow>('Orders.EaseBuzzSettings');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Key = "Key",
            Salt = "Salt",
            WebhookUrl = "WebhookUrl",
            RedirectUrl = "RedirectUrl",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
